/**
 * @license lucide-react v0.570.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const __iconNode = [
  ["path", { d: "M19 11v6", key: "rcqigv" }],
  ["path", { d: "M19 13h2", key: "1gch44" }],
  ["path", { d: "M2 21a8 8 0 0 1 12.868-6.349", key: "1lryzn" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }]
];
const UserRoundKey = createLucideIcon("user-round-key", __iconNode);

export { __iconNode, UserRoundKey as default };
//# sourceMappingURL=user-round-key.js.map
